var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeftGray14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7803 13.6436C10.4874 13.9365 10.0126 13.9365 9.71967 13.6436L3.71967 7.64361C3.42678 7.35072 3.42678 6.87584 3.71967 6.58295L9.71967 0.582952C10.0126 0.290058 10.4874 0.290058 10.7803 0.582952C11.0732 0.875844 11.0732 1.35072 10.7803 1.64361L5.31066 7.11328L10.7803 12.583C11.0732 12.8758 11.0732 13.3507 10.7803 13.6436Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftGray14);
export default __webpack_public_path__ + "static/media/chevron_left_gray_14.108bfd0d47bdeb601c7509556fc68a4b.svg";
export { ForwardRef as ReactComponent };